import FooterDesktop from "@Components/FooterV2/FooterDesktop";
import ThreeStepsSection from "../components/ThreeStepsSection";
import TrustPilotReviewsBanner from "@Pages/Search/components/SearchList/components/TrustPilotBanner";
import { Helmet } from "react-helmet";
import useTranslationHook from "hooks/useTranslationHook";
import ZendeskChat from "@Pages/PropertyPage/components/ZendeskChat";
import wrapperHOC from "@Utils/wrapperHOC";
import HeroV2 from "./Components/HeroV2/HeroV2";
import ReferralsTable from "./Components/ReferralsTable/ReferralsTable";

const ReferralDesktop = () => {
  const { t } = useTranslationHook();
  return (
    <>
      <Helmet title={t("referral.meta.title")} />
      <HeroV2 isReferralPage />
      <ReferralsTable />
      <ThreeStepsSection />
      <TrustPilotReviewsBanner isHomePage isDesktop uniCity={null} />
      <FooterDesktop />
      <ZendeskChat />
    </>
  );
};

export default wrapperHOC(ReferralDesktop, {
  componentName: "ReferralDesktop",
  showForChina: true,
});
